<template>
  <footer class="footer">
    <div>
      <a-row>
        <a-col :span="8">
          <ul>
            <li>关于我们</li>
            <li><a href="#">xxx简介</a></li>
          </ul>
        </a-col>
        <a-col :span="8">
          <ul>
            <li>联系我们</li>
            <li>微信：</li>
            <li>电话：</li>
            <li>地址：</li>
          </ul>
        </a-col>
        <a-col :span="8">
          <div class="qrcode animate__animated animate__fadeIn">
            <img :src="tenantInfo.qrcode" alt="" />
          </div>
        </a-col>
      </a-row>
    </div>
    <div class="copyright">
      Copyright © {{ tenantInfo.brandName }}
      <a href="http://beian.miit.gov.cn/">{{ tenantInfo.footer.beian }}</a>
    </div>
  </footer>
</template>
<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
export default {
  name: "Footer",
  data() {
    return {
      tenantInfo: {},
    };
  },
  created() {
    this.tenantInfo = Vue.ls.get(TENANT_CONFIG);

  },
};
</script>
<style lang="less" scoped>
footer {
  background: #3d3e49;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 15px;
  ul {
    li {
      text-align: left;
      color: white;
      list-style: none;
    }
    li:first-child {
      font-size: 20px;
    }
  }
  .qrcode {
    width: 200px;
    height: 200px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .copyright {
    color: white;
  }
}
</style>